<template>
  <!-- BEGIN pos-counter-header -->
  <div class="pos-counter-header">
    <div class="logo">
      <router-link to="/admin/pos/restaurant-sales">
        <div class="logo-img"><img src="@/assets/logo.svg" /></div>
        <div class="logo-text ts-whitespace-no-wrap">
          <div>{{ $t('restaurantSale.pineAndDine') }}</div>
          <div class="ts-text-sm ts-text-right ts-font-semibold">{{ time }}</div>
        </div>
      </router-link>
    </div>
    <div class="mb-md-0 d-flex ts-whitespace-no-wrap ts-space-x-2 business-unit">
      <div class="align-items-center ts-pl-1 ts-whitespace-no-wrap">
        <div class="simple-business-unit">
          <span class="ts-whitespace-no-wrap">
            <b>{{ $store.state.authUser.user.name }}</b>
            ({{ $store.state.authUser.counter ? $store.state.authUser.counter[0].counter_name : '' }})
          </span>
          <br>
          <span>
            <b>B.U :</b>
            {{ $store.state.authUser.user.current_business ? $store.state.authUser.user.current_business : 'All' }}
          </span>
        </div>
        <div class="small-business-unit">
          <span class="ts-whitespace-no-wrap">
            <b>{{ $store.state.authUser.user.name }}</b>
          </span>
          <br>
          <span class="ts-whitespace-no-wrap">
            ({{ $store.state.authUser.counter ? $store.state.authUser.counter[0].counter_name : '' }})
          </span>
          <br>
          <span>
            <b>B.U :</b>
            {{ $store.state.authUser.user.current_business }}
          </span>
        </div>
      </div>
    </div>
    <div class="mb-2 mb-md-0 d-flex ts-whitespace-no-wrap ts-space-x-2 table-status" style="width: 50%;">
      <div class="d-flex align-items-center me-3">
        {{ $t('restaurantSale.availableTable') }} ({{
          tableBusy + '/' + totalTable
        }})
      </div>
      <div class="d-flex align-items-center me-3">
        <i class="fa fa-circle fa-fw text-gray-500 ts-mb-1"></i>
        {{ $t('restaurantSale.reserved') }}
      </div>
      <div class="d-flex align-items-center me-3">
        <i class="fa fa-circle fa-fw text-warning ts-mb-1"></i>
        {{ $t('restaurantSale.tableInUse') }}
      </div>
      <div class="d-flex align-items-center me-3">
        <i class="fa fa-circle fa-fw text-theme ts-mb-1"></i>
        {{ $t('restaurantSale.tableAvailable') }}
      </div>
    </div>
    <!-- <div class="time" id="time">{{ time }}</div> -->
    <div class="nav d-flex ts-whitespace-no-wrap" style="flex-wrap: nowrap;">
      <div class="d-flex align-items-center">
        <a-switch v-model="lock_value" @change="onChangeLock">
          <template #checkedChildren><i class="fas fa-lock"></i></template>
          <template #unCheckedChildren><i class="fas fa-lock-open"></i></template>
        </a-switch>
      </div>
      <div class="d-flex align-items-center" v-if="!fullscreen">
        <button @click="$emit('openFullscreen')" v-tooltip="'Open Fullscreen'" class="nav-link">
          <i class="fas fa-expand fa-2x"></i>
        </button>
      </div>
      <div class="d-flex align-items-center" v-if="fullscreen">
        <button @click="$emit('closeFullscreen')" v-tooltip="'Close Fullscreen'" class="nav-link">
          <i class="fas fa-compress fa-2x"></i>
        </button>
      </div>
      <b-dropdown class="d-flex align-items-center languages" variant="link" menu-class="p-b-0">
        <template slot="button-content">
          <span :class="`flag-icon flag-icon-${flag} ts-text-lg`" :title="flag"></span>
        </template>
        <b-dropdown-item href="#" v-for="language in languages" :key="language.code"
          @click="$emit('changeLanguage', language)">
          <span :class="`flag-icon flag-icon-${language.icon} ts-text-lg`" :title="language.icon"></span>
          {{ language.caption }}
        </b-dropdown-item>
      </b-dropdown>
      <div class="nav-item d-flex align-items-center">
        <router-link to="/admin/restaurant-kdu" class="nav-link" v-tooltip="$t('restaurantSale.kitchenDisplayUnit')">
          <svg viewBox="0 0 16 16" class="nav-icon" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
              d="M1.161 8a6.84 6.84 0 1 0 6.842-6.84.58.58 0 0 1 0-1.16 8 8 0 1 1-6.556 3.412l-.663-.577a.58.58 0 0 1 .227-.997l2.52-.69a.58.58 0 0 1 .728.633l-.332 2.592a.58.58 0 0 1-.956.364l-.643-.56A6.812 6.812 0 0 0 1.16 8zm5.48-.079V5.277h1.57c.881 0 1.416.499 1.416 1.32 0 .84-.504 1.324-1.386 1.324h-1.6zm0 3.75V8.843h1.57l1.498 2.828h1.314L9.377 8.665c.897-.3 1.427-1.106 1.427-2.1 0-1.37-.943-2.246-2.456-2.246H5.5v7.352h1.141z" />
          </svg>
        </router-link>
      </div>
      <div class="nav-item d-flex align-items-center">
        <router-link to="/admin/table-bookings" v-tooltip="$t('restaurantSale.tableBooking')" class="nav-link">
          <svg viewBox="0 0 16 16" class="nav-icon" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
              d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
            <path
              d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z" />
          </svg>
        </router-link>
      </div>
      <div class="nav-item d-flex align-items-center">
        <router-link to="/" v-tooltip="$t('home')" class="nav-link">
          <i class="fas fa-home fa-2x"></i>
        </router-link>
      </div>
    </div>
  </div>
  <!-- END pos-counter-header -->
</template>

<script>
export default {
  name: 'PosCounterHeader',
  props: {
    time: {
      type: String,
      default: '00:00'
    },
    tableBusy: {
      type: Number,
      default: 0
    },
    totalTable: {
      type: Number,
      default: 0
    },
    flag: {
      type: String,
      default: 'us'
    },
    languages: {
      type: Array,
      default: () => []
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    lock: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    lock_value: {
      get() {
        return this.lock
      },
      set(value) {
        this.$emit('update:lock', value)
      }
    },
  },
  methods: {
    onChangeLock() {
      this.$emit('onChangeLock')
    }
  }
}
</script>
<style lang="scss" scoped>
.business-unit {
  padding: 0 100px 0 8px;
}

.simple-business-unit {
  display: block;
}

.small-business-unit {
  display: none;
}

@media (max-width: 1287px) {

  .pos-counter .pos-counter-header .nav .nav-item {
    display: none !important;
  }

  .business-unit {
    padding: 0 90px 0 8px;
  }
}

@media (max-width: 991.98px) {

  .pos-counter .pos-counter-header .time,
  .nav .nav-item {
    display: none !important;
  }

  .pos-counter .pos-counter-header .table-status {
    display: none !important;
  }

  .business-unit {
    padding: 0 50px 0 8px;
  }
}

@media (max-width: 575.98px) {

  .pos-counter .pos-counter-header .table-status {
    display: none !important;
  }

  .business-unit {
    padding: 0 8px 0 8px;
  }

  .pos-counter .pos-counter-header {
    padding: 10px 10px;
  }

  .simple-business-unit {
    display: none;
  }

  .small-business-unit {
    display: block;
    font-size: 9px;
  }

  .logo-text {
    margin-left: 0 !important;
  }

  .nav-link {
    padding: 0.5rem 0.5rem;
  }

  .languages .btn {
    padding: 6px 6px;
  }
}
</style>